export default "__VITE_ASSET__DxE21NOo__"